export const getCroppedImg = async (originalResolution, imageSrc, cropData) => {

    try {
        const image = await createImage(imageSrc)
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')

        canvas.width = originalResolution.width
        canvas.height = originalResolution.height
        ctx.drawImage(
            image,
            cropData.x,
            cropData.y,
            cropData.width,
            cropData.height,
            0,
            0,
            canvas.width,
            canvas.height
        )

        return canvas.toDataURL('image/jpeg')

    } catch (error) {
        return error.type
    }
    
}

const createImage = (url) => new Promise((resolve, reject) => {
    const image = new Image()
    image.addEventListener('load', () => resolve(image))
    image.addEventListener('error', error => reject(error))
    image.setAttribute('crossOrigin', 'anonymous')
    image.src = url
})

export const getRatioValue = (a, b) => (b === 0) ? a : getRatioValue(b, a % b);